module.exports = __webpack_public_path__ + "static/media/bid.32070c74.svg";